import { useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";
import { Axios } from "../../../Api/axios";
import {
  ADMIN_ALL_CLASSES,
  SUBJECTS_BY_CLASS,
  ADMIN_ADD_LECTURE,
} from "../../../Api/Api";
import LoadingSubmit from "../../../Components/Loading/Loading";
import DashDialog from "../../../Components/Dashboard/DashDialog";
import { useNavigate } from "react-router-dom";

export default function AddLesson() {
  const nav = useNavigate();

  const [classes,         setClasses]         = useState([]);
  const [selectedClassId, setSelectedClassId] = useState("");
  const [subjects,        setSubjects]        = useState([]);
  const [subjectsLoading, setSubjectsLoading] = useState(false);
  const [classSubjectId,  setClassSubjectId]  = useState("");

  const [pdfFile,   setPdfFile]   = useState(null);
  const [videoFile, setVideoFile] = useState(null);
  const [examFile,  setExamFile]  = useState(null);

  const [pdfUrl,   setPdfUrl]   = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const [examUrl,  setExamUrl]  = useState("");

  const [loading, setLoading] = useState(false);

  const classRef = useRef(null);

  useEffect(() => { classRef.current?.focus(); }, []);

  useEffect(() => {
    Axios.get(ADMIN_ALL_CLASSES)
      .then((res) => setClasses(res.data.classes || res.data || []))
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!selectedClassId) { setSubjects([]); setClassSubjectId(""); return; }
    setSubjectsLoading(true);
    setClassSubjectId("");
    Axios.get(SUBJECTS_BY_CLASS(selectedClassId))
      .then((res) => setSubjects(res.data.subjects || []))
      .catch(() => setSubjects([]))
      .finally(() => setSubjectsLoading(false));
  }, [selectedClassId]);

  async function handleSubmit() {
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("class_subject_id", classSubjectId);
      if (pdfFile)   fd.append("pdf",       pdfFile);
      if (pdfUrl)    fd.append("pdf_url",   pdfUrl.trim());
      if (videoFile) fd.append("video",     videoFile);
      if (videoUrl)  fd.append("video_url", videoUrl.trim());
      if (examFile)  fd.append("exam",      examFile);
      if (examUrl)   fd.append("exam_url",  examUrl.trim());
      await Axios.post(ADMIN_ADD_LECTURE, fd);
      nav("/dashboard/products");
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  }

  const isValid = !!classSubjectId;

  return (
    <>
      {loading && <LoadingSubmit />}
      <DashDialog
        title="إضافة درس جديد"
        onSubmit={handleSubmit}
        submitDisabled={!isValid || loading}
        submitLabel={loading ? "جاري الحفظ..." : "حفظ الدرس"}
      >
        {/* Class selector */}
        <Form.Group className="mb-4" controlId="classSelect">
          <Form.Label>الصف</Form.Label>
          <Form.Select
            ref={classRef}
            value={selectedClassId}
            onChange={(e) => setSelectedClassId(e.target.value)}
          >
            <option value="">اختر الصف...</option>
            {classes.map((c) => (
              <option key={c.id} value={c.id}>{c.name}</option>
            ))}
          </Form.Select>
        </Form.Group>

        {/* Subject selector */}
        <Form.Group className="mb-4" controlId="subjectSelect">
          <Form.Label>المادة</Form.Label>
          <Form.Select
            value={classSubjectId}
            onChange={(e) => setClassSubjectId(e.target.value)}
            disabled={!selectedClassId || subjectsLoading}
          >
            <option value="">
              {subjectsLoading ? "جاري التحميل..." : "اختر المادة..."}
            </option>
            {subjects.map((s) => {
              const csId = s.classSubject?.id;
              return csId ? (
                <option key={s.id} value={csId}>{s.name}</option>
              ) : null;
            })}
          </Form.Select>
          {selectedClassId && !subjectsLoading && subjects.length === 0 && (
            <Form.Text className="text-muted">لا توجد مواد لهذا الصف</Form.Text>
          )}
        </Form.Group>

        {/* PDF */}
        <FileField
          label="ملف PDF"
          accept=".pdf,application/pdf"
          file={pdfFile}
          onChange={(f) => { setPdfFile(f); if (f) setPdfUrl(""); }}
          icon="📄"
          disabled={!classSubjectId}
          url={pdfUrl}
          onUrlChange={(v) => { setPdfUrl(v); if (v) setPdfFile(null); }}
        />

        {/* Video */}
        <FileField
          label="ملف الفيديو"
          accept="video/*"
          file={videoFile}
          onChange={(f) => { setVideoFile(f); if (f) setVideoUrl(""); }}
          icon="🎬"
          disabled={!classSubjectId}
          url={videoUrl}
          onUrlChange={(v) => { setVideoUrl(v); if (v) setVideoFile(null); }}
        />

        {/* Exam */}
        <FileField
          label="ملف الاختبار"
          accept=".pdf,application/pdf,.doc,.docx"
          file={examFile}
          onChange={(f) => { setExamFile(f); if (f) setExamUrl(""); }}
          icon="📝"
          disabled={!classSubjectId}
          url={examUrl}
          onUrlChange={(v) => { setExamUrl(v); if (v) setExamFile(null); }}
        />
      </DashDialog>
    </>
  );
}

function FileField({ label, accept, file, onChange, icon, disabled, url, onUrlChange }) {
  const ref = useRef(null);
  return (
    <Form.Group className="mb-4">
      <Form.Label>{label} <span style={{ color: "#9ca3af", fontWeight: 400, fontSize: "0.8rem" }}>(اختياري)</span></Form.Label>
      <input
        ref={ref}
        type="file"
        accept={accept}
        style={{ display: "none" }}
        onChange={(e) => onChange(e.target.files[0] || null)}
        disabled={disabled}
      />

      {/* File zone */}
      {file ? (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 14px", border: "1.5px solid #00a74f", borderRadius: "10px", background: "#f0fdf4", marginBottom: 8 }}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <span style={{ fontSize: "1.2rem" }}>{icon}</span>
            <div>
              <p style={{ margin: 0, fontSize: "0.84rem", fontWeight: 600, color: "#374151" }}>{file.name}</p>
              <p style={{ margin: 0, fontSize: "0.75rem", color: "#6b7280" }}>
                {file.size < 900 * 1024
                  ? (file.size / 1024).toFixed(1) + " KB"
                  : (file.size / (1024 * 1024)).toFixed(2) + " MB"}
              </p>
            </div>
          </div>
          <button type="button" onClick={() => { onChange(null); ref.current.value = ""; }} style={{ border: "none", background: "none", color: "#ef4444", cursor: "pointer", fontSize: "0.85rem", fontWeight: 600 }}>
            ✕ حذف
          </button>
        </div>
      ) : (
        <div
          onClick={() => !disabled && ref.current.click()}
          style={{ border: `2px dashed ${disabled ? "#e5e7eb" : "#00a74f"}`, borderRadius: "10px", padding: "14px 16px", textAlign: "center", cursor: disabled ? "not-allowed" : "pointer", background: disabled ? "#f9fafb" : "#f0fdf4", transition: "all 0.2s", marginBottom: 8 }}
        >
          <span style={{ fontSize: "1.4rem", display: "block", marginBottom: "3px" }}>{icon}</span>
          <p style={{ margin: 0, fontSize: "0.82rem", fontWeight: 600, color: disabled ? "#9ca3af" : "#00a74f" }}>
            {disabled ? "اختر الصف والمادة أولاً" : `اضغط لرفع ${label}`}
          </p>
        </div>
      )}

      {/* URL input */}
      {!file && (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <div style={{ flex: 1, position: "relative" }}>
            <span style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", fontSize: "0.85rem", color: "#9ca3af", pointerEvents: "none" }}>🔗</span>
            <input
              type="url"
              value={url}
              onChange={(e) => onUrlChange(e.target.value)}
              disabled={disabled}
              placeholder="أو أدخل رابط URL..."
              style={{ width: "100%", padding: "8px 34px 8px 12px", border: "1.5px solid #e5e7eb", borderRadius: 8, fontSize: "0.83rem", color: "#374151", background: disabled ? "#f9fafb" : "#fff", outline: "none", direction: "rtl" }}
            />
          </div>
          {url && (
            <button type="button" onClick={() => onUrlChange("")} style={{ border: "none", background: "none", color: "#ef4444", cursor: "pointer", fontWeight: 600, fontSize: "0.85rem", whiteSpace: "nowrap" }}>
              ✕
            </button>
          )}
        </div>
      )}
    </Form.Group>
  );
}
